export const STUDENT = "student";
export const TEACHER = "teacher";
export const INSTITUTION = "institution";
